export const PropertyListVariant = {
  Standalone: 'standalone',
  Inline: 'inline',
} as const;

export type PropertyListVariantType =
  (typeof PropertyListVariant)[keyof typeof PropertyListVariant];

export type PropertyListProps = {
  /** Section title shown at the top of the card. */
  title: string;
  /** Optional text shown below the title. */
  description?: string;
  variant?: PropertyListVariantType;
  testId?: string;
};

export type PropertyListSlots = {
  title?: () => unknown;
  description?: () => unknown;
  actions?: () => unknown;
  trailing?: () => unknown;
  default?: () => unknown;
};
